import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import Info from "../../components/pages/PersonalDataPolicy/Info/Info";

const PersonalDataPolicyPage: React.FC = () => {
  return (
    <Layout>
      <Info />
      <Feedback />
    </Layout>
  );
};

export default PersonalDataPolicyPage;
